import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from 'emotion';

import theme from 'site-react/theme';

const titleStyles = css`
  margin: 0;
  color: ${theme.colors.white};
  float: left;
  font-family: ${theme.font.family.default};
  font-size: ${theme.font.size.xs};
  font-weight: ${theme.font.weight.medium};
  text-transform: uppercase;
`;

/**
 * A drawer header title component
 * @param {any} props
 */
const DrawerTitle = ({ className, title }) => (
  <h2
    className={cx(titleStyles, className)}
    data-testid={`DrawerTitle-${title}`}
  >
    {title}
  </h2>
);

DrawerTitle.defaultProps = {
  title: null,
  className: '',
};

DrawerTitle.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
};

export default DrawerTitle;
